<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <ExistedDialog :state="existedDialog" :id="existedId" @close="closeExisted" />
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>THÊM KHÁCH HÀNG TIỀM NĂNG</v-toolbar-title>
        <v-spacer />
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-6">
        <v-form v-bind="this.$attrs" ref="form">
          <h3 class="pb-6">1. Thông tin liên lạc</h3>

          <v-text-field label="Tên PHHS" v-model="contact.buyerName" outlined hide-details dense />
          <v-text-field
            label="Điện thoại"
            required
            type="tel"
            v-model="contact.phone"
            :rules="[$rules.required, $rules.phone]"
            outlined
            class="pt-6 required"
            dense
          />
          <v-text-field label="Email" type="email" v-model="contact.email" outlined :rules="[$rules.email]" dense />

          <h3 class="pb-6">2. Thông tin nhu cầu</h3>
          <v-autocomplete
            clearable
            flat
            outlined
            dense
            hide-details
            placeholder="Hình thức học"
            :items="studentLearningMethodOptions"
            item-text="value"
            item-value="key"
            v-model="studentLearningMethods"
            class="mb-3"
            multiple
          />
          <v-autocomplete
            clearable
            flat
            outlined
            dense
            hide-details
            placeholder="Khoá học muốn tham gia"
            :items="studentProductOptions"
            item-text="value"
            item-value="key"
            v-model="studentProducts"
            multiple
            class="mb-3"
          />
          <v-autocomplete
            clearable
            flat
            outlined
            dense
            hide-details
            placeholder="Cơ sở đăng ký"
            :items="studentDepartmentOptions"
            item-text="value"
            item-value="key"
            v-model="studentDepartments"
            multiple
            class="mb-3"
          />

          <h3>3. Thông tin học sinh</h3>
          <div class="px-0 pt-6">
            <div class="d-flex">
              <div class="pb-6 d-flex" style="flex-grow: 1">
                <v-text-field
                  label="Tên học sinh"
                  v-model="studentName"
                  outlined
                  hide-details
                  style="flex-grow: 1"
                  class="pr-6"
                  dense
                />
                <v-text-field label="Trường" v-model="studentSchool" outlined hide-details style="flex-grow: 1" dense />
              </div>
            </div>

            <div class="d-flex">
              <div class="pb-6 d-flex" style="flex-grow: 1">
                <DateIOSPicker label="Ngày sinh (dd/mm/yyyy)" style="width: 100%" v-model="studentDob" />
              </div>
            </div>
          </div>

          <h3 class="pb-6">4. Thông tin chăm sóc</h3>
          <div v-for="(product, index) in saleInfo.products" :key="product.id">
            <div class="d-flex justify-space-between pb-6">
              <v-select
                :items="getAvailableProducts(index)"
                item-text="title"
                item-value="id"
                v-model="saleInfo.products[index]"
                :label="`Chọn sản phẩm quan tâm ${index + 1}`"
                return-object
                outlined
                hide-details
                dense
              />
              <v-icon class="ml-6" @click="removeProduct(index)">mdi-trash-can</v-icon>
            </div>
          </div>
          <div class="d-flex justify-space-between">
            <v-spacer />
            <v-btn outlined color="blue darken-4" @click="addProduct">Thêm</v-btn>
          </div>
          <v-select
            label="Mức độ quan tâm"
            :items="interestOptions"
            item-text="label"
            item-value="value"
            v-model="saleInfo.interest"
            outlined
            hide-details
            class="py-6"
            dense
          />
          <v-select
            label="Phân khúc"
            :items="segmentOptions"
            item-text="label"
            item-value="value"
            v-model="saleInfo.segment"
            outlined
            hide-details
            dense
          />
          <v-text-field label="Nguồn" v-model="saleInfo.origin" outlined hide-details class="py-6" dense />
          <v-textarea label="Ghi chú" v-model="saleInfo.note" outlined hide-details dense />
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy</v-btn>
        <v-spacer />
        <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import utils from '@/plugins/utils'
import ExistedDialog from './ExistedDialog.vue'
import { mapActions, mapGetters } from 'vuex'
import DateIOSPicker from '../picker/DateIOSPicker.vue'
import { CONFIG_KEYS } from '../../../views/crm/lead/helpers'
import get from 'lodash-es/get'

const isProductEmpty = product =>
  !product || Object.keys(product).length === 0 || !product.id || Object.values(product).every(val => !val)

export default {
  props: { state: Boolean, users: Array },
  components: { ExistedDialog, DateIOSPicker },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) this.loading = false
    },
  },
  computed: {
    ...mapGetters({ user: 'auth/user', products: 'product/products', configs: 'leadConfig/configs' }),
    productOptions() {
      const product = this.products.map(product => ({
        label: product.name,
        value: product.id,
      }))
      return product
    },
    allProducts() {
      if (!this.products) return []
      return this.products.filter(item => !this.saleInfo.products.some(product => product.id === item.id))
    },
    studentLearningMethodOptions() {
      const config = this.configs.find(c => c.key === CONFIG_KEYS.STUDENT_LEARNING_METHOD)
      return get(config, 'value', [])
    },
    studentProductOptions() {
      const config = this.configs.find(c => c.key === CONFIG_KEYS.STUDENT_PRODUCT)
      return get(config, 'value', [])
    },
    studentDepartmentOptions() {
      const config = this.configs.find(c => c.key === CONFIG_KEYS.STUDENT_DEPARTMENT)
      return get(config, 'value', [])
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      selectedProduct: null,
      existedDialog: false,
      existedId: '',
      contact: {
        buyerName: '',
        phone: '',
        email: '',
      },
      studentName: '',
      studentSchool: '',
      studentDob: '',
      studentProducts: [],
      studentDepartments: [],
      studentLearningMethods: [],

      saleInfo: {
        products: [{}],
        interest: '',
        segment: '',
        origin: '',
        note: '',
      },

      interestOptions: [
        { label: 'Thấp', value: 'cold' },
        { label: 'Vừa', value: 'warm' },
        { label: 'Cao', value: 'hot' },
      ],
      segmentOptions: [
        { label: 'Phổ thông', value: 'intermediate' },
        { label: 'Cao cấp', value: 'advance' },
      ],
    }
  },
  methods: {
    ...mapActions('lead', ['createLead']),

    close() {
      this.$emit('closeDialog')
      this.resetForm()
      this.$refs.form.resetValidation()
    },
    removeProduct(index) {
      if (this.saleInfo.products.length > 1) {
        this.saleInfo.products.splice(index, 1)
      } else {
        this.$set(this.saleInfo.products, index, {})
      }
    },
    addProduct() {
      this.saleInfo.products.push('')
    },
    getAvailableProducts(index) {
      const currentProductId = this.saleInfo.products[index].id
      return this.products.filter(
        product =>
          product.id === currentProductId ||
          !this.saleInfo.products.some(selectedProduct => selectedProduct.id === product.id)
      )
    },
    async submit() {
      const isValid = this.$refs.form.validate()
      if (!isValid) return
      this.$loading.active = true

      // Prepare data

      // Filter out empty products
      const filteredProducts = this.saleInfo.products.filter(product => !isProductEmpty(product))
      this.saleInfo.products = filteredProducts
      let lead = {
        ...this.contact,
        ...this.saleInfo,
        studentName: this.studentName,
        studentDob: this.studentDob,
        studentSchool: this.studentSchool,
        studentLearningMethods: this.studentLearningMethods,
        studentDepartments: this.studentDepartments,
        studentProducts: this.studentProducts,
      }

      // Additional lead fields processing
      lead.createdByName = this.user.name
      lead.inCharge = this.user.id
      lead.studentNameSearchField = utils.removeUnicode(this.studentName).toLowerCase()
      lead.studentSchoolSearchField = utils.removeUnicode(this.studentSchool).toLowerCase()
      // API call to create the lead
      try {
        await this.createLead({ ...lead })
        this.$alert.success('Tạo mới khách hàng tiềm năng thành công')
        this.$emit('refresh')
        this.close()
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    closeExisted() {
      this.existedDialog = false
    },
    resetForm() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
  },
}
</script>

<style>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 2px !important;
}
</style>
